import {State} from '../types/state'

export const isItemOpened = (state: State, eventId: string) => state.layout.listItemOpened === eventId
